import React from "react";


export default function RightPanel({children,showRightMenu,setShowRightMenu,isCart}){
    if(isCart){
        return(
            <div className={showRightMenu ? "aside_info_wrapper show p-0" : "aside_info_wrapper p-0"}>
                <div className="aside_info_inner">
                    {children}
                </div>
            </div>    
        )
    }
    else{
        return(
        <div className={showRightMenu ? "aside_info_wrapper show" : "aside_info_wrapper"}>
            <button className="aside_close" onClick={()=>setShowRightMenu(false)}>Close <i className="bi bi-x-lg"></i></button>
            <div className="aside_info_inner">
                {children}
            </div>
        </div>        
    )}
}